import React from "react"

import TimeLimit      from "../../../types/TimeLimit"
import IconTimeLimit  from "../../common/Icons/TimeLimit"
import ItemViewHeader from "../../common/Headers/ItemViewHeader"

export interface componentProps {
    item: TimeLimit
}

const Header: React.FC<componentProps> = ({item}) => {
    const linkSegment = 'form'
        , text = item.name
        , title = text ? text : '-'

    return <ItemViewHeader
        icon={<IconTimeLimit link={'/time-limits/' + item.id + '/' + linkSegment} text={text} />}
        title={title}
        subTitle={item.description || ''}
    />
}

export default Header